export default __webpack_public_path__ + "static/media/zoom-out.4482a163.svg";